import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { isDecimalPistolTarget } from '../imported-target.parser';

@Component({
  selector: 'app-rezultati',
  templateUrl: './rezultati.component.html',
  styleUrls: ['./rezultati.component.scss']
})
export class RezultatiComponent implements OnInit, OnDestroy {
  private readonly importedTargetXmlKey = 'tarce.importedTargetXml';
  private readonly importedTargetAssignmentsKey = 'tarce.importedTargetAssignments';
  resultsTargets: any[] = [];
  allResultsTargets: any[] = [];
  filteredResultsTargets: any[] = [];
  readonly resultsPageSize = 100;
  visibleResultsCount = 100;
  dockDown = false;
  private displaySettingsLoaded = false;
  private targetDisplaySettings = {
    grid_rows: 2,
    targets_per_row: 5,
    target_display_mode: 'rotate-pages',
    target_rotation_seconds: 15
  };
  RezultatiAddDialogOpen = false;
  selectedTarget: any = null;
  TarcaAddDialogOpen = false;
  selectedMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  monthPickerOpen = false;
  importedTargetAvailable = false;
  importedTargetAssignments: { [targetId: string]: boolean } = {};
  savedXmlTargets: any[] = [];
  selectedXmlTargetIds: { [targetId: string]: number | null } = {};
  selectedResultTargetId: number | null = null;
  selectedMember = '';
  selectedCompetition = '';
  selectedCategory = '';
  selectedClub = '';
  memberFilterSearch = '';
  competitionFilterSearch = '';
  categoryFilterSearch = '';
  clubFilterSearch = '';
  openFilter: 'member' | 'competition' | 'category' | 'club' | null = null;
  private refreshInterval: ReturnType<typeof setInterval> | null = null;

  readonly monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'];

  constructor(private http: HttpClient) {}

  get isUnitTwo(): boolean {
    return localStorage.getItem('unit_id') === '2';
  }

  toggleDock(enabled: boolean): void {
    this.dockDown = enabled;
    this.saveTargetDisplaySettings();
    this.loadTargets(this.dockDown);
  }

  loadTargets(Proba: boolean = true, resetPagination: boolean = true): void {
    const apiUrl = 'https://testapi.ovh/api/strelstvo/targets';
    const unitId = localStorage.getItem('unit_id');
    let params = new HttpParams()
      .set('Proba', Proba ? 'true' : 'false')
      .set('month', String(this.selectedMonth.getMonth() + 1))
      .set('year', String(this.selectedMonth.getFullYear()));

    const token = localStorage.getItem('access_token');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    if (unitId) {
      params = params.set('unit_id', unitId);
    }

    // console.log(apiUrl + '?' + params.toString());

    this.http.get<any[]>(apiUrl, { params, headers }).subscribe(
      (data) => {
        this.allResultsTargets = Array.isArray(data) ? data : [];
        this.applyFilters(resetPagination);
        this.loadTargetXmlAssignments();
      },
      (error) => {
        console.error('Error loading targets:', error);
        this.allResultsTargets = [];
        this.filteredResultsTargets = [];
        this.resultsTargets = [];
      }
    );
  }

  get memberOptions(): string[] {
    return this.uniqueValues('member_full_name');
  }

  get competitionOptions(): string[] {
    return this.uniqueValues('competition_name');
  }

  get categoryOptions(): string[] {
    return this.uniqueValues('category_name');
  }

  get clubOptions(): string[] {
    return this.uniqueValues('club_name');
  }

  get filteredMemberOptions(): string[] {
    return this.filterOptions(this.memberOptions, this.memberFilterSearch);
  }

  get filteredCompetitionOptions(): string[] {
    return this.filterOptions(this.competitionOptions, this.competitionFilterSearch);
  }

  get filteredCategoryOptions(): string[] {
    return this.filterOptions(this.categoryOptions, this.categoryFilterSearch);
  }

  get filteredClubOptions(): string[] {
    return this.filterOptions(this.clubOptions, this.clubFilterSearch);
  }

  private filterOptions(options: string[], search: string): string[] {
    const value = search.trim().toLocaleLowerCase('sl');
    return value ? options.filter(option => option.toLocaleLowerCase('sl').includes(value)) : options;
  }

  selectFilter(filter: 'member' | 'competition' | 'category' | 'club', value: string): void {
    if (filter === 'member') {
      this.selectedMember = value;
      this.memberFilterSearch = value;
    } else if (filter === 'competition') {
      this.selectedCompetition = value;
      this.competitionFilterSearch = value;
    } else if (filter === 'category') {
      this.selectedCategory = value;
      this.categoryFilterSearch = value;
    } else {
      this.selectedClub = value;
      this.clubFilterSearch = value;
    }
    this.openFilter = null;
    this.applyFilters();
  }

  clearFilter(filter: 'member' | 'competition' | 'category' | 'club'): void {
    this.selectFilter(filter, '');
  }

  private uniqueValues(field: string): string[] {
    return Array.from(new Set(
      this.allResultsTargets
        .map(target => String(target?.[field] ?? '').trim())
        .filter(Boolean)
    )).sort((first, second) => first.localeCompare(second, 'sl'));
  }

  applyFilters(resetPagination: boolean = true): void {
    if (resetPagination) {
      this.visibleResultsCount = this.resultsPageSize;
    }

    this.filteredResultsTargets = this.allResultsTargets.filter(target =>
      (!this.selectedMember || target.member_full_name === this.selectedMember) &&
      (!this.selectedCompetition || target.competition_name === this.selectedCompetition) &&
      (!this.selectedCategory || target.category_name === this.selectedCategory) &&
      (!this.selectedClub || target.club_name === this.selectedClub)
    );
    this.resultsTargets = this.filteredResultsTargets.slice(0, this.visibleResultsCount);
  }

  get hasMoreResults(): boolean {
    return this.resultsTargets.length < this.filteredResultsTargets.length;
  }

  showNextResults(): void {
    this.visibleResultsCount += this.resultsPageSize;
    this.resultsTargets = this.filteredResultsTargets.slice(0, this.visibleResultsCount);
  }

  clearFilters(): void {
    this.selectedMember = '';
    this.selectedCompetition = '';
    this.selectedCategory = '';
    this.selectedClub = '';
    this.memberFilterSearch = '';
    this.competitionFilterSearch = '';
    this.categoryFilterSearch = '';
    this.clubFilterSearch = '';
    this.openFilter = null;
    this.applyFilters();
  }

  ngOnInit(): void {
    this.importedTargetAvailable = !!localStorage.getItem(this.importedTargetXmlKey);
    this.loadImportedTargetAssignments();
    this.loadTargetDisplaySettings();
    this.loadSavedXmlTargets();
    this.refreshInterval = setInterval(() => {
      if (this.displaySettingsLoaded) {
        this.loadTargets(this.dockDown, false);
      }
    }, 10000);
  }

  ngOnDestroy(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }

  formatServerDate(value: string | Date | null | undefined): string {
    if (!value) return '';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Ljubljana',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(date).reduce<Record<string, string>>((result, part) => {
      result[part.type] = part.value;
      return result;
    }, {});

    return `${parts['hour']}:${parts['minute']} ${parts['day']}:${parts['month']}:${parts['year']}`;
  }

  private normalizeTargetType(targetType: unknown): string {
    return String(targetType || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  private isDecimalXmlTarget(target: any): boolean {
    const xmlTargetId = this.selectedXmlTargetIds[String(target?.targetID)];
    const xmlTarget = this.savedXmlTargets.find(item => Number(item.id) === Number(xmlTargetId));
    return !!xmlTarget?.definition && isDecimalPistolTarget(xmlTarget.definition);
  }

  isDecimalTarget(target: any): boolean {
    const targetType = this.normalizeTargetType(target?.target_type);
    return this.isDecimalXmlTarget(target) || ['air rifle', 'air rifle teiler', 'pistol decimal'].includes(targetType);
  }

  formatSeriesScore(value: any, target?: any): string {
    const score = Number(value);
    if (!Number.isFinite(score) || score === 0) return '';
    return this.isDecimalTarget(target) ? score.toFixed(1) : Math.round(score).toString();
  }

  formatTotalScore(target: any): string {
    const score = Number(target?.series_sum);
    if (!Number.isFinite(score)) return '';
    return this.isDecimalTarget(target) ? score.toFixed(1) : Math.round(score).toString();
  }

  private loadTargetDisplaySettings(): void {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    if (!token) {
      this.displaySettingsLoaded = true;
      this.loadTargets(this.dockDown);
      return;
    }

    this.http.get<any>('https://testapi.ovh/api/strelstvo/target-display-settings', { headers, params }).subscribe({
      next: settings => {
        this.targetDisplaySettings = {
          ...this.targetDisplaySettings,
          ...settings
        };
        this.dockDown = settings?.show_test_targets === true || Number(settings?.show_test_targets) === 1;
        this.displaySettingsLoaded = true;
        this.loadTargets(this.dockDown);
      },
      error: error => {
        console.error('Error loading target display settings:', error);
        this.displaySettingsLoaded = true;
        this.loadTargets(this.dockDown);
      }
    });
  }

  private saveTargetDisplaySettings(): void {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    if (!token) return;

    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;
    this.http.put('https://testapi.ovh/api/strelstvo/target-display-settings', {
      ...this.targetDisplaySettings,
      show_test_targets: this.dockDown
    }, { headers, params }).subscribe({
      error: error => console.error('Error saving target display settings:', error)
    });
  }

  private loadSavedXmlTargets(): void {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    if (!token || !unitId) return;
    this.http.get<any[]>('https://testapi.ovh/api/strelstvo/xml-targets', {
      headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
      params: new HttpParams().set('unit_id', unitId)
    }).subscribe({
      next: targets => {
        this.savedXmlTargets = Array.isArray(targets) ? targets : [];
        this.importedTargetAvailable = this.savedXmlTargets.length > 0 || this.importedTargetAvailable;
      },
      error: error => console.error('Error loading saved XML targets:', error)
    });
  }

  private loadTargetXmlAssignments(): void {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    if (!token || !unitId) return;
    const targetIds = this.resultsTargets.map(target => target.targetID).filter(Boolean).join(',');
    if (!targetIds) return;
    this.http.get<any[]>('https://testapi.ovh/api/strelstvo/target-xml-assignments', {
      headers: new HttpHeaders({ Authorization: `Bearer ${token}` }),
      params: new HttpParams().set('unit_id', unitId).set('target_ids', targetIds)
    }).subscribe({
      next: assignments => {
        this.selectedXmlTargetIds = {};
        (Array.isArray(assignments) ? assignments : []).forEach(assignment => {
          this.selectedXmlTargetIds[String(assignment.target_id)] = assignment.xml_target_id || null;
        });
      },
      error: error => console.error('Error loading XML target assignments:', error)
    });
  }

  assignXmlTarget(targetId: number, xmlTargetId: string | number | null): void {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const key = String(targetId);
    if (!token || !unitId) return;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    const params = new HttpParams().set('unit_id', unitId);
    const previousXmlTargetId = this.selectedXmlTargetIds[key] || null;
    const normalizedXmlTargetId = xmlTargetId ? Number(xmlTargetId) : null;

    if (!xmlTargetId) {
      this.http.delete(`https://testapi.ovh/api/strelstvo/targets/${targetId}/xml-target`, { headers, params }).subscribe({
        next: () => this.selectedXmlTargetIds[key] = null,
        error: error => {
          this.selectedXmlTargetIds[key] = previousXmlTargetId;
          console.error('Error clearing XML target assignment:', error);
        }
      });
      return;
    }
    this.http.put(`https://testapi.ovh/api/strelstvo/targets/${targetId}/xml-target`, {
      xml_target_id: normalizedXmlTargetId
    }, { headers, params }).subscribe({
      next: () => this.selectedXmlTargetIds[key] = normalizedXmlTargetId,
      error: error => {
        this.selectedXmlTargetIds[key] = previousXmlTargetId;
        console.error('Error assigning XML target:', error);
      }
    });
  }

  getTargetTypeDisplay(target: any): string {
    const xmlTargetId = this.selectedXmlTargetIds[String(target?.targetID)];
    const xmlTarget = this.savedXmlTargets.find(item => Number(item.id) === Number(xmlTargetId));
    return xmlTarget?.display_name || target?.target_type || '-';
  }

  isTeilerTarget(target: any): boolean {
    return String(target?.target_type || '').trim().toLowerCase().endsWith('teiler');
  }

  private loadImportedTargetAssignments(): void {
    try {
      const savedAssignments = localStorage.getItem(this.importedTargetAssignmentsKey);
      this.importedTargetAssignments = savedAssignments ? JSON.parse(savedAssignments) : {};
    } catch {
      this.importedTargetAssignments = {};
    }
  }

  isImportedTargetAssigned(targetId: number): boolean {
    return !!this.importedTargetAssignments[String(targetId)];
  }

  toggleImportedTarget(targetId: number): void {
    if (!this.importedTargetAvailable) return;

    const key = String(targetId);
    if (this.importedTargetAssignments[key]) {
      delete this.importedTargetAssignments[key];
    } else {
      this.importedTargetAssignments[key] = true;
    }

    localStorage.setItem(
      this.importedTargetAssignmentsKey,
      JSON.stringify(this.importedTargetAssignments)
    );
  }

  get selectedMonthLabel(): string {
    return `${this.monthLabels[this.selectedMonth.getMonth()]} ${this.selectedMonth.getFullYear()}`;
  }

  previousMonth(): void {
    this.selectedMonth = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() - 1, 1);
    this.monthPickerOpen = false;
    this.loadTargets(this.dockDown);
  }

  nextMonth(): void {
    this.selectedMonth = new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 1);
    this.monthPickerOpen = false;
    this.loadTargets(this.dockDown);
  }

  toggleMonthPicker(): void {
    this.monthPickerOpen = !this.monthPickerOpen;
  }

  selectMonth(monthIndex: number): void {
    this.selectedMonth = new Date(this.selectedMonth.getFullYear(), monthIndex, 1);
    this.monthPickerOpen = false;
    this.loadTargets(this.dockDown);
  }

  isSelectedMonth(monthIndex: number): boolean {
    return this.selectedMonth.getMonth() === monthIndex;
  }

  openTarcaAddDialog() {
    this.TarcaAddDialogOpen = true;
  }

  closeTarcaAddDialog() {
    this.TarcaAddDialogOpen = false;
    this.loadTargets(this.dockDown);
  }

  openRezultatiAddDialog(target: any) {
    // Pass a copy to avoid mutating the table directly
    this.selectedTarget = { ...target };
    this.RezultatiAddDialogOpen = true;
  }

  closeAddRezultatiDialog() {
    this.RezultatiAddDialogOpen = false;
    this.selectedTarget = null;
    // Optionally reload your targets here
    this.loadTargets(this.dockDown);
  }

  copyTarget(target: any) {
    const apiUrl = `https://testapi.ovh/api/strelstvo/targets/${target.targetID}/copy`;
    console.log('Calling copyTarget API:', { target, apiUrl });
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
    const params = unitId ? new HttpParams().set('unit_id', unitId) : undefined;

    this.http.post(apiUrl, {}, { headers, params }).subscribe(
      (response: any) => {
        console.log('Copy response:', response);
        this.loadTargets(this.dockDown);
      },
      (error) => {
        console.error('Copy error:', error);
      }
    );
  }
}
